import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";
import { borders } from "aviary-tokens";

import { animations, dimensions } from "@styles";

const HEIGHTS = css`
  width: 100%;
  max-width: 36.5rem;
  max-height: 36.5rem;
  @media (min-width: ${dimensions.desktop}) {
    max-width: unset;
  }
`;

export const galleryWrapper = {
  showGallery: css`
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-direction: column-reverse;

    @media (min-width: ${dimensions.desktop}) {
      flex-direction: row;
      align-items: start;
      height: auto;
    }
  `,
  noGallery: css`
    display: flex;
    justify-content: center;
  `,
};

export const mainImage = {
  base: (theme: Theme) => css`
    position: relative;
    ${HEIGHTS}
    flex: 1;

    .aviary-product-image {
      ${HEIGHTS}

      width: 100%;
      height: 100%;

      img {
        ${HEIGHTS}

        border: 1px solid ${theme.system.borderBase};
        border-radius: ${borders.radiusBase};
      }
    }
  `,
  borderless: css`
    .aviary-product-image {
      img {
        border-color: transparent;
        &:hover,
        &:active {
          border-color: transparent;
        }
      }
    }
  `,
};

export const imgButton = {
  base: (theme: Theme) => css`
    padding: 0;
    img {
      border: 1px solid ${theme.system.borderBase};
      border-radius: ${borders.radiusBase};
      ${animations.transition()};

      &:hover {
        border-color: ${theme.system.borderHover};
      }

      &:active {
        border-color: ${theme.system.borderActive};
      }
    }
  `,
  active: (theme: Theme) => css`
    img {
      border-color: ${theme.system.borderActive};
    }
  `,
};

export const searchIcon = (theme: Theme) => css`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  width: 1.5rem;
  padding: 0.25rem 0;

  color: ${theme.light.textBase};
`;
